import { Injectable } from "@angular/core";
import { RestService } from "./rest-service";
import { MmcTenantInfo } from "app/models/mmc/mmc-tenant-info";
import { UserMmcInfo } from "app/models/mmc/user-mmc-info";
import { PagedResults } from "app/models/paged-results";
import { SetMmcAffiliateDto } from "app/models/set-mmc-affiliate-dto";
import { MmcGetDispatchCommandStatusDto } from "app/models/mmc/mmc-get-dispatch-command-status-dto";
import { Url_Base } from "app/rest-constants";

@Injectable()
export class MmcService {

  constructor(
    private restService: RestService
  ) { }

  private getUrl(): string {
    return `${Url_Base}/mmc/`;
  }

  public isMmcEnabled(): Promise<boolean> {
    const callUrl = `${this.getUrl()}enabled`;
    return this.restService.get<boolean>(callUrl);
  }

  public getTenantInfo(): Promise<MmcTenantInfo> {
    const callUrl = `${this.getUrl()}tenant`;
    return this.restService.get<MmcTenantInfo>(callUrl);
  }

  public getAffiliates(): Promise<string[]> {
    const callUrl = `${this.getUrl()}affiliates`;
    return this.restService.get<string[]>(callUrl);
  }

  public getPrinters(): Promise<string[]> {
    const callUrl = `${this.getUrl()}printers`;
    return this.restService.get<string[]>(callUrl);
  }

  public getUsersMmcInfo(pageNumber: number, pageSize: number, filterValue?: string): Promise<PagedResults<UserMmcInfo>> {
    const callUrl = `${this.getUrl()}user-mmc-info?start=${pageNumber}&size=${pageSize}&filterColumn=login&sortColumn=login&filterString=${filterValue == null? "" : filterValue}`;
    return this.restService.get<PagedResults<UserMmcInfo>>(callUrl);
  }

  public setUsersMmcAffiliate(userIds: number[], mmcAffiliate: string): Promise<void> {
    const callUrl = `${this.getUrl()}user-mmc-info`;
    return this.restService.post<void>(callUrl, { user_ids: userIds, mmc_affiliate: mmcAffiliate } as SetMmcAffiliateDto)
  }

  public getDispatchCommandStatus(dispatchId: number): Promise<MmcGetDispatchCommandStatusDto> {
    const callUrl = `${this.getUrl()}dispatch/${dispatchId}/command-status`;
    return this.restService.get<MmcGetDispatchCommandStatusDto>(callUrl);
  }
  
}